// extracted by mini-css-extract-plugin
export default {"button":"ScrollTopButton_button__H2k-Z","visible":"ScrollTopButton_visible__Q1wT1"};